import { SET_CONFIGURATION_LAYOUT } from '@/store/mutation-types'

const state = {}

const getters = {
  sidebar: (state) => state.sidebar || 'floating',
  central: (state) => state.central || 'customerservice',
  cacheTime: (state) => state.cacheTime || 3,
  consignmentPagePreferences: (state) => state.consignmentPagePreferences || [ 'header', 'information', 'items', 'pricing and margin', 'tracking', 'tracking errors', 'manifest pricing', 'quoted pricing' ],
  consignmentLinkPopoverEnabled: (state) => state.consignmentLinkPopoverEnabled || false,
  headerColour: (state) => state.headerColour || false,
  tableSize: (state) => state.tableSize || 'default',
  keyboardShortcutsEnabled: (state) => state.keyboardShortcutsEnabled || false
}

const mutations = {
  [SET_CONFIGURATION_LAYOUT] (state, data) {
    //
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
